import { render, staticRenderFns } from "./PrintMediaItem.vue?vue&type=template&id=32c37a4e"
import script from "./PrintMediaItem.vue?vue&type=script&lang=js"
export * from "./PrintMediaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports